import React, { Component } from "react"
import autobind from "class-autobind"
import { IJobDocument } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import TableActionBar from "../../../components/layout/TableActionBar"
import { IPayTypeBudget } from "../../../models/data/PayTypeBudget"
import AppStateStore from "../../../stores/AppStateStore"
import ContentAdd from "material-ui/svg-icons/content/add"
import { FloatingActionButton, CircularProgress } from "material-ui"
import JobDetailBudgetTable from "../../../components/job/JobDetailBudgetTable"
import AddJobDetailPayTypeBudgetDialog from "../../../components/job/AddJobDetailPayTypeBudgetDialog"
import * as api from "../../../api"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import * as jobHelper from "../../../helpers/jobHelper"
import accountStore from "../../../stores/AccountStore"

interface IProps {
    readonly?: boolean
    job: IJobDocument
    reloadJob(): void
    loading: boolean
}
interface IState {
    openAddBudgetItemDialog: boolean
    selectedBudgetItems: IPayTypeBudget[]
    editBudgetItem: IPayTypeBudget
}

export default class JobDetailBudget extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddBudgetItemDialog: false,
            editBudgetItem: null,
            selectedBudgetItems: [],
        }
        autobind(this)
    }

    addBudgetItem(item: IPayTypeBudget) {
        AppStateStore.setProgressSnackbarContent("loading")
        if (!item.RegularTime && !item.OTTime && !item.OT2Time) {
            item.PayTypeName = payGroupAndTypeHelper.getPayTypeNameById(item.PayTypeId)
        }

        this.props.job.PayTypeBudgetItems.push(item)

        api.updateJob(this.props.job).then(() =>
            AppStateStore.setProgressSnackbarContent(strings.Successfully_created)
        )
    }

    updateBudgetItem(item) {
        AppStateStore.setProgressSnackbarContent("loading")
        if (!item.RegularTime && !item.OTTime && !item.OT2Time) {
            item.PayTypeName = payGroupAndTypeHelper.getPayTypeNameById(item.PayTypeId)
        }

        let objIndex = this.props.job.PayTypeBudgetItems.findIndex(obj => jobHelper.comparePayTypeBudgets(this.state.editBudgetItem, obj))
        this.props.job.PayTypeBudgetItems[objIndex] = item

        api.updateJob(this.props.job).then(() => {
            AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
            this.setState({ selectedBudgetItems: [] })
        })
    }

    deleteBudgetItems(deleteBudgetItems: IPayTypeBudget[]) {
        AppStateStore.setProgressSnackbarContent("loading")
        const payTypeBudgetItems = this.props.job.PayTypeBudgetItems
        this.props.job.PayTypeBudgetItems = payTypeBudgetItems.filter(i =>
            deleteBudgetItems.find(deleteItem => jobHelper.comparePayTypeBudgets(deleteItem, i)) ? false : true
        )
        api.updateJob(this.props.job).then(() => {
            AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
            this.setState({ selectedBudgetItems: [] })
        })
    }

    render() {
        return (
            <div className="user-detail-tab" style={{ padding: 30 }}>
                {!this.props.readonly &&
                    <FloatingActionButton
                        data-intercom-target={`menu-Jobs-JobDetails-Budget-Btn-Add`}
                        className="fixed-add"
                        style={{ right: 80, top: -15, zIndex: 998 }}
                        secondary onTouchTap={() => this.setState({ openAddBudgetItemDialog: true })}>
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <TableActionBar
                    searchText={""}
                    rowSelectionCount={this.state.selectedBudgetItems.length}
                    singleSelectedMessage={strings.Budget_Selected}
                    multipleSelectedMessage={strings.x_Budgets_Selected}
                    title={jobHelper.checkJobFieldAvailable('singular') ? `Weekly ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Budget`:strings.Weekly + " " + strings.Job + " " + strings.Budget}
                    onDeleteClick={() =>
                        AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_delete_selected_budgets,
                            confirm: () => {
                                this.deleteBudgetItems(this.state.selectedBudgetItems)
                                this.setState({ selectedBudgetItems: [] })
                            }
                        })
                    }
                    readonly={this.props.readonly}
                />
                {this.props.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    (!this.props.job.PayTypeBudgetItems || this.props.job.PayTypeBudgetItems.length === 0) ?
                        <div>
                            <h2 style={{ textAlign: "center", marginTop: 25 }}>
                                { jobHelper.checkJobFieldAvailable('singular') ? `No weekly ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel.toLowerCase()} budget items found`: strings.No_weekly_job_budget_items_found}
                            </h2>
                        </div> :
                        <JobDetailBudgetTable
                            readonly={this.props.readonly}
                            payTypeBudgetItems={this.props.job.PayTypeBudgetItems}
                            selectedItems={this.state.selectedBudgetItems}
                            handleSelect={selectedBudgetItems => this.setState({ selectedBudgetItems })}
                            handleUpdate={editBudgetItem => this.setState({ openAddBudgetItemDialog: true, editBudgetItem: editBudgetItem })}
                        />
                }
                {this.state.openAddBudgetItemDialog &&
                    <AddJobDetailPayTypeBudgetDialog
                        editJobPayTypeBudgetItem={this.state.editBudgetItem}
                        exitJobPayTypeBudgetItems={this.props.job.PayTypeBudgetItems || []}
                        handleClose={() => this.setState({ openAddBudgetItemDialog: false, editBudgetItem: null })}
                        handleAdd={this.addBudgetItem}
                        handleUpdate={this.updateBudgetItem}
                    />
                }
            </div>
        )
    }
}